
const firebaseConfig = {
  apiKey: "AIzaSyAVIAZ1mUZVJJ3kzK3_jMf1BBfP_FwxwG0",
  authDomain: "mrtravel-4ad23.firebaseapp.com",
  projectId: "mrtravel-4ad23",
  storageBucket: "mrtravel-4ad23.appspot.com",
  messagingSenderId: "86399836375",
  appId: "1:86399836375:web:ff0a9eddc69345f7875092"
};

export default firebaseConfig;